import React from "react";

import FormInputMasked from "./form.input";

import type { FormEvents } from "utilities/events";

export type Props = {|
  ...FormEvents,
  +children?: React.Node,
  +className?: string,
  +action?: string,
  +method?: string,
  +autoComplete: "on" | "off",
|};

function Form({
  className,
  children,
  action,
  method,
  onSubmit,
  autoComplete,
}: Props): React.Node {
  return (
    <form
      className={className}
      onSubmit={(e) => {
        onSubmit(e);
        e.preventDefault();
      }}
      action={action}
      method={method}
      autoComplete={autoComplete}
    >
      {children}
    </form>
  );
}

Form.defaultProps = {
  autoComplete: "off",
  method: "POST",
};

Form.Input = FormInputMasked;

export default Form;
